import React from 'react';
import { View, Dimensions } from 'react-native';

import { map as _map } from 'lodash';
import PropTypes from 'prop-types';

import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';

import TimelineBar from './TimelineBar';
import styles from './TimelineBars.Styles';

function TimelineBars({ dates, slot }) {
  const timeLineBars = _map(Object.entries(dates), ([date, value], index) => {
    return <TimelineBar slot={slot} key={index} date={{ date, ...value }} />;
  });

  return <View style={styles.container}>{timeLineBars}</View>;
}
TimelineBars.defaultProps = {
  theme: LightThemeColors,
  slot: Dimensions.get('window').width / 6,
  isMonthView: true,
};
TimelineBars.propTypes = {
  getDaysArray: PropTypes.func,
  isMonthView: PropTypes.bool,
  data: PropTypes.array,
  slot: PropTypes.number,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  dates: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};
export default withTheme(TimelineBars);
